import { render, staticRenderFns } from "./JsohTable.vue?vue&type=template&id=511014bd&scoped=true"
import script from "./JsohTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./JsohTable.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511014bd",
  null
  
)

export default component.exports